import { Box, Divider, Flex, FlexProps, Text, VStack } from '@chakra-ui/react'
import { ThemeContext, ThemeContextData } from '@hb/react'
import {
  currentMentalHealthCareProviderDetailsField,
  FieldMapValue,
  hasCurrentMentalHealthCareProviderField,
  neurologicalPsychologicalFieldGroups,
  UploadProgress,
} from '@hb/shared'

import { conditionsOrDiseasesFieldGroups } from '@hb/shared/src/fields/gyn/conditionsOrDiseases'
import {
  healthHistoryField,
  healthHistoryHeightField,
  healthHistoryWeightField,
} from '@hb/shared/src/fields/gyn/healthHistory'
import { injuriesAndSurgeriesField } from '@hb/shared/src/fields/gyn/injuringAndSurgeries'
import { FORM_ERROR } from 'final-form'
import { useState } from 'react'
import { ActionLog } from '../ActionLog'
import { CollapseError } from '../CollapseError'
import { CorrectionsProvider, ShareCorrectionsProvider } from '../DataView/context'
import { InnerForm } from '../forms/FinalForm/InnerForm'
import { SimpleFormFooter } from '../forms/FinalForm/SimpleForm'
import { FormElement } from '../forms/Input'
import { RenderStageProps } from '../forms/renderStage/types'
import { ConditionGroupView } from './ConditionGroupView'

const themeData: ThemeContextData = {
  theme: 'detailed',
  placeholderAbove: true,
}
const formFooterFlexProps: FlexProps = {
  pb: 0,
}

export const HealthHistoryStage = ({
  data,
  corrections,
  onSubmit,
  onComplete,
  registerForm,
}: RenderStageProps) => {
  const { updatedOn, updatedBy, updatedByGroup } = data ?? {}

  const [uploads, setUploads] = useState<Record<string, UploadProgress> | null>(null)
  const [initData] = useState<FieldMapValue>(data ?? {})

  return (
    <ThemeContext.Provider value={themeData}>
      <CorrectionsProvider corrections={corrections ?? null}>
        <ShareCorrectionsProvider shared={corrections?.correctionsShared ?? null}>
          <InnerForm
            field={healthHistoryField}
            data={initData}
            key="health-history-stage"
            setUploads={setUploads}
            closeOnSuccess
            onClose={onComplete}
            onSubmit={onSubmit}
            registerForm={registerForm}>
            {({ errors, submitErrors }) => {
              const body = (
                <>
                  {/* <FormElement
                    root
                    index={0}
                    active
                    disabled={!!readOnly}
                    showName={false}
                    name=""
                    field={healthHistoryField}
                  /> */}
                  <Flex w="100%" flexFlow="column" gap={1} py={1}>
                    <FormElement field={healthHistoryHeightField} active name="height" />
                    <FormElement field={healthHistoryWeightField} active name="weight" />
                  </Flex>
                  <Divider my={2} />
                  <Text fontWeight={500} color="gray.600" fontFamily="Open Sans" fontSize="lg">
                    Conditions and Diseases
                  </Text>
                  {conditionsOrDiseasesFieldGroups.map(fieldGroup => (
                    <ConditionGroupView
                      stageId="healthHistory"
                      basePath="conditionsOrDiseases"
                      key={Object.keys(fieldGroup)[0]}
                      fieldGroup={fieldGroup}
                    />
                  ))}
                  <Divider my={2} />
                  <Text fontWeight={500} color="gray.600" fontFamily="Open Sans" fontSize="lg">
                    Neurological and Psychological
                  </Text>
                  <FormElement
                    field={hasCurrentMentalHealthCareProviderField}
                    active
                    name="hasCurrentMentalHealthCareProvider"
                  />
                  <FormElement
                    field={currentMentalHealthCareProviderDetailsField}
                    active
                    name="currentMentalHealthCareProviderDetails"
                  />
                  {neurologicalPsychologicalFieldGroups.map(fieldGroup => (
                    <ConditionGroupView
                      stageId="healthHistory"
                      basePath="neurologicalPsychological"
                      key={Object.keys(fieldGroup)[0]}
                      fieldGroup={fieldGroup}
                    />
                  ))}
                  <Divider my={2} />
                  <Text fontWeight={500} color="gray.600" fontFamily="Open Sans" fontSize="lg">
                    Injuries and Surgeries
                  </Text>
                  <FormElement
                    field={injuriesAndSurgeriesField}
                    active
                    name="injuriesAndSurgeries"
                  />
                  {updatedBy || updatedOn || updatedByGroup ? (
                    <Box px={4} py={1}>
                      <ActionLog
                        action="Updated"
                        by={updatedBy}
                        on={updatedOn}
                        group={updatedByGroup}
                      />
                    </Box>
                  ) : null}
                </>
              )
              return (
                <VStack
                  borderRadius={4}
                  align="flex-start"
                  bg="gray.50"
                  width="100%"
                  height="100%"
                  spacing={0}
                  borderTop="1px solid #cdcdcd"
                  shadow="md">
                  <Box py={3} px={4} flex={1} minH="0" w="100%" overflowY="auto">
                    {body}
                  </Box>
                  <Box px={4}>
                    <CollapseError
                      style={{ paddingTop: '0' }}
                      error={errors?.[FORM_ERROR] || submitErrors?.[FORM_ERROR]}
                    />
                  </Box>
                  <SimpleFormFooter
                    uploads={uploads}
                    canSubmitClean
                    flexProps={formFooterFlexProps}
                    theme="detailed"
                    submitText="SAVE"
                    submitCleanText="SAVE"
                  />
                </VStack>
              )
            }}
          </InnerForm>
        </ShareCorrectionsProvider>
      </CorrectionsProvider>
    </ThemeContext.Provider>
  )
}
